import React, { forwardRef } from 'react';

import MUISnackbar, {
  SnackbarProps as MUISnackbarProps,
} from '@material-ui/core/Snackbar';

interface SnackbarProps extends MUISnackbarProps {}

const Snackbar = forwardRef<HTMLDivElement, SnackbarProps>((props, ref) => {
  const {
    onEnter,
    onEntered,
    onEntering,
    onExited,
    onExiting,
    ...rest
  } = props;

  return <MUISnackbar {...rest} ref={ref} />;
});

Snackbar.displayName = 'Snackbar';

export default Snackbar;
